<script>
  import { darkenColor } from '../../lib/logic/utils.js';
  import { BINDER_DARKEN_FACTOR } from '../../lib/logic/config.js';
  import { swipe } from '../../lib/actions/swipe.js';

  let { binderColor = '#b75c5c', onSwipeLeft, onSwipeRight, children } = $props();

  const borderColor = $derived(darkenColor(binderColor, BINDER_DARKEN_FACTOR));
  const stitchColor = $derived(darkenColor(binderColor, BINDER_DARKEN_FACTOR));
</script>

<div
  class="binder-container"
  style:background-color={binderColor}
  style:--binder-border-color={borderColor}
  style:--binder-stitch-color={stitchColor}
  use:swipe={{ onSwipeLeft, onSwipeRight }}
>
  {@render children()}
</div>

<style>
  .binder-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: auto;
    box-shadow:
      0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05),
      inset -2px 0 4px rgba(0, 0, 0, 0.15),
      inset 0 2px 4px rgba(255, 255, 255, 0.1);
    overflow: visible;
    position: relative;
    border: 1px solid var(--binder-border-color, #5a8a69);
    border-width: 3px;
    z-index: var(--z-binder-shell, 2);
    background-color: #b75c5c;
    background-image:
      /* Denim diagonal twill weave */
      repeating-linear-gradient(
        45deg,
        transparent,
        transparent 1.5px,
        rgba(0, 0, 0, 0.025) 1.5px,
        rgba(0, 0, 0, 0.025) 3px
      ),
      repeating-linear-gradient(
        135deg,
        transparent,
        transparent 1.5px,
        rgba(255, 255, 255, 0.015) 1.5px,
        rgba(255, 255, 255, 0.015) 3px
      ),
      /* Denim fabric texture noise */
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='150' height='150' viewBox='0 0 150 150'%3E%3Cfilter id='denimNoise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch' seed='5'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23denimNoise)' opacity='0.08'/%3E%3C/svg%3E");
    transition:
      background-color 0.2s,
      border-radius 0.1s,
      padding 0.1s;
    touch-action: pan-y;
    perspective: 2500px;
    box-sizing: border-box;
    padding-top: var(--binder-shell-padding-y, 0.7rem);
    padding-bottom: var(--binder-shell-padding-y, 0.7rem);

    /* Mobile: flush left, rounded corners right only */
    border-radius: 0 var(--binder-corner-radius, 1.6rem) var(--binder-corner-radius, 1.6rem) 0;
    padding-right: var(--binder-shell-padding-x, 0rem);
    padding-left: 0;
    border-left-width: 0;
    justify-content: flex-start;
  }

  /* During horizontal swipe, prevent vertical scroll */
  .binder-container:global(.swiping-x) {
    touch-action: none;
  }

  /* Inner cover stitching */
  .binder-container::before {
    content: '';
    position: absolute;
    border: 2px dashed var(--binder-stitch-color, #5a8a69);
    pointer-events: none;
    z-index: var(--z-binder-stitch, 1);
    transition:
      border-radius 0.1s,
      top 0.1s,
      left 0.1s,
      right 0.1s,
      bottom 0.1s;
    top: var(--binder-stitch-inset, 0.25rem);
    right: var(--binder-stitch-inset, 0.25rem);
    bottom: var(--binder-stitch-inset, 0.25rem);
  }

  /* Mobile: binder shrinks to fit viewport minus drawer */
  @media (max-width: 767px) {
    .binder-container {
      flex-shrink: 1;
      min-height: 0;
    }
  }

  /* Mobile: hide left stitch */
  @media (max-width: 767px) {
    .binder-container::before {
      left: -100px;
      border-radius: 0
        calc(var(--binder-corner-radius, 1.6rem) - var(--binder-stitch-inset, 0.25rem))
        calc(var(--binder-corner-radius, 1.6rem) - var(--binder-stitch-inset, 0.25rem)) 0;
    }
  }

  /* Desktop: full binder with both sides */
  @media (min-width: 768px) {
    .binder-container {
      border-top-left-radius: var(--binder-corner-radius, 1.6rem);
      border-bottom-left-radius: var(--binder-corner-radius, 1.6rem);
      padding-left: var(--binder-shell-padding-x, 0rem);
      border-left-width: 3px;
      width: 100%;
      height: auto;
      flex-shrink: 1;
      min-height: 0;
    }

    .binder-container::before {
      left: var(--binder-stitch-inset, 0.25rem);
      border-radius: calc(
        var(--binder-corner-radius, 1.6rem) - var(--binder-stitch-inset, 0.25rem)
      );
    }
  }
</style>
